export const environment = {
  production: false,
  apiUrl: 'https://pms.devapifyxt.com',
  insightsApiUrl: 'https://insights.devapifyxt.com/api',
  appName: 'AMS - Agent Management Service',
  version: '0.0.0',
};
